import noReferrer from 'Furillo/modules/no-referrer.js';
import ajaxPartials from 'Furillo/modules/ajax-partials.js';
import ajaxForms from 'Furillo/modules/ajax-forms.js';
import cookieHelper from 'Furillo/modules/cookie-helper.js';
import TagFilter from 'Furillo/modules/tag-filter.js';
import { extendedMainNavigation, extendedSubNavigation } from 'Furillo/modules/navigation.js';
import extendedModal from 'Furillo/modules/modal.js';
import Collapse from 'Vendor/bootstrap/js/dist/collapse.js';
import Offcanvas from 'Vendor/bootstrap/js/dist/offcanvas.js';
import Alert from 'Vendor/bootstrap/js/dist/alert.js';
import lazysizes from 'Vendor/lazysizes/lazysizes.js';
import { videoBanner } from 'Furillo/modules/video-banner.js';
import { animate } from 'Furillo/modules/animate.js';
import { ValidationService } from 'Vendor/aspnet-client-validation/dist/aspnet-validation.js';
import FundraiserVisualization from './modules/fundraiser.js';

export default document.addEventListener('DOMContentLoaded', function () {

    let v = new ValidationService();
    v.addProvider('requiretrue', (value, element, params) => {
        if (!value)            
            return false;

        if (element.getAttribute('type') === 'checkbox' && !element.checked)
            return false;

        return true;
    });
    v.bootstrap();

    // Add noreferrer to links
    noReferrer(document.querySelector('body'));

    // Modify default behaviour of navbar (main navigation)
    extendedMainNavigation(document.querySelector('#site > header nav.navbar'));

    // If sub menu on page, enable fetching sub-levels through ajax
    const subNavigation = document.querySelector('#site nav.sub-navigation');
    if (subNavigation)
        extendedSubNavigation(subNavigation);

    // Init ajax partials
    ajaxPartials.init(document.querySelector('body'));

    // Init ajax forms
    ajaxForms.init(document.querySelector('body'));

    // Lazy load of videos
    videoBanner();

    // Animtaions
    animate();

    // Check for image blocks and add possibility to open as modal
    const images = document.querySelectorAll('.block-image a.open-image-modal, .block-media-list a.open-image-modal');
    if (images && images.length > 0) {
        images.forEach(image => {
            image.setAttribute('data-bs-toggle', 'modal');
            image.setAttribute('data-bs-target', '#shared-modal');
        });
    }

    // Init the shared modal to handle images and galleries
    extendedModal(document.querySelector('#shared-modal'));

    // Check for lists with tag filters and add filtering
    document.querySelectorAll('.block-page-list').forEach(list => {

        let filters = list.querySelector('.tag-filters');
        if (filters) {
            new TagFilter(filters, { listWrapper: list });
        }
    });

    // Workaround, in Bootstrap v5.1.3 one could have "visibility: hidden" on the
    // offcanvas in order to hide it at load (no flicker). This no longer works so
    // lets remove them here once DOM is loaded.
    document.querySelectorAll('.offcanvas').forEach(element => {
        element.removeAttribute('style');
    });

    // System Messages
    document.querySelectorAll('#site > header > div[data-type="system-message"]').forEach(element => {
        element.addEventListener('close.bs.alert', event => {

            const id = parseInt(event.target.getAttribute('data-id'));
            if (isNaN(id))
                return;

            var cookie = cookieHelper.get('read_messages');
            var messages = [];
            if (cookie && cookie.length > 0) {
                messages = cookie.split('|');
            }

            messages.push(id);

            cookieHelper.set('read_messages', messages.join('|'), 7);
        });
    });


    // Since Bootstrap 5 Theme needs other markup we need to handle displaying
    // the validation messages manually for RadioButtonList and CheckBoxList
    const forms = document.querySelectorAll('div.umbraco-forms-form > form');
    if (forms && forms.length > 0) {
        forms.forEach(form => {

            //// When SEO Checker messes with redirects
            //let action = form.getAttribute('action');
            //if (!action.endsWith('/')) {
            //    form.setAttribute('action', action + '/');
            //}

            form.addEventListener('validation', function (e) {

                if (e.detail.valid)
                    return;

                const displayListValidationMessages = function (selector) {
                    e.target.querySelectorAll(selector).forEach(list => {

                        let check = list.querySelector('input.input-validation-error');
                        if (!check)
                            return;

                        let id = check.getAttribute('name');
                        list.parentNode.querySelector('span[data-valmsg-for="' + id + '"]').style.display = 'inline-block';
                    });
                };

                displayListValidationMessages('.radiobuttonlist');
                displayListValidationMessages('.checkboxlist');
            });
        });
    }

    const fundraiserContainer = document.getElementById('fundraiser-container');
    if (fundraiserContainer) {
        new FundraiserVisualization(fundraiserContainer);
    }
});